import { connect } from 'react-redux';
import { fetchChatUsers, fetchChatUser, invalidateLiveViewData, blockChatUser } from 'src/legacy/redux/actions/chatUsers.jsx';
import { initiateSmallTalkSession, invalidateSmallTalkSession } from 'src/legacy/redux/actions/smallTalk.jsx';
import ChatUsersListView from './view.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks'
import _ from 'lodash';

import { trackAdoptionMetricsForRecipientSelectedEvent, trackAdoptionMetricsForAllRecipientsToggledEvent, trackAdoptionMetricsForViewerFilterAppliedEvent } from 'src/legacy/redux/actions/adoption.jsx';

const mapStateToProps = (state) => {
  return{
    account: _.get(state, "accounts.item"),
    chatUsers: _.get(state.legacyRootReducer, `chatUser.items`),
    chatUser: _.get(state.legacyRootReducer, `chatUser.item`),
    engageEnabled: _.get(state.legacyRootReducer, `smallTalk.initiated`),
    loading: _.get(state.legacyRootReducer, `chatUser.loading`),
    totalRecords: _.get(state.legacyRootReducer, `chatUser.pagination.totalRecordsCount`),
    currentPage: _.get(state.legacyRootReducer, `chatUser.pagination.currentPage`),
    totalPages: _.get(state.legacyRootReducer, `chatUser.pagination.totalPages`),
    blocking: _.get(state.legacyRootReducer, `chatUser.item.blocking`) || false
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    fetchChatUsers: (page, filter, isGlobal) => {
      return dispatch(fetchChatUsers(page, filter, isGlobal));
    },

    fetchChatUser: (chatUserId) => {
      return dispatch(fetchChatUser(chatUserId));
    },

    initiateSmallTalkSession: (contact) => {
      return dispatch(initiateSmallTalkSession(contact));
    },

    invalidateSmallTalkSession: (contact) => {
      return dispatch(invalidateSmallTalkSession(contact));
    },

    invalidateLiveViewData: () => {
      return dispatch(invalidateLiveViewData());
    }, 
    
    blockChatUser: (chatUserId, blocked) => {
      return dispatch(blockChatUser(chatUserId, blocked));
    },

    trackAdoptionMetricsForRecipientSelectedEvent: () => {
      return dispatch(trackAdoptionMetricsForRecipientSelectedEvent());
    },

    trackAdoptionMetricsForAllRecipientsToggledEvent: () => {
      return dispatch(trackAdoptionMetricsForAllRecipientsToggledEvent());
    },

    trackAdoptionMetricsForViewerFilterAppliedEvent: (filter) => {
      return dispatch(trackAdoptionMetricsForViewerFilterAppliedEvent(filter));
    },
  }
}

const ChatUsersListPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatUsersListView)

export default withUseHooks(ChatUsersListPage);